import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ContentLoading, ErrorPage } from 'axway-react-ui';
import * as actions from '../actions';
import CredentialsView from '../view/CredentialsView';

class Credentials extends React.Component {
	constructor(props) {
		super(props);
		this.fetchCredentials = this.fetchCredentials.bind(this);
		this.showToastNotification = this.showToastNotification.bind(this);
		this.hideToastNotification = this.hideToastNotification.bind(this);
	}

	fetchCredentials() {
		this.props.actions.fetchCredentials();
	}

	// updates the state for show the toast notification
	showToastNotification(time, message) {
		this.props.actions.showToastNotification(time, message);
	}

	// updates the state for hide the toast notification passed to the Toast callback onClose
	hideToastNotification() {
		this.props.actions.hideToastNotification();
	}

	render() {
		const { loading, error, errorDetail, credentials, toast } = this.props;
		if (error) {
			return <ErrorPage errorDetail={errorDetail} />;
		} else if (credentials.length || !loading) {
			return (
				<CredentialsView
					credentials={credentials}
					toast={toast}
					onRefresh={this.fetchCredentials}
					onShowToast={this.showToastNotification}
					onHideTost={this.hideToastNotification}

				/>
			);
		}
		return <ContentLoading />;
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	const namedCreds = Object.entries((state.credentials && state.credentials.credentials) || {})
		.map(([ name, cred ]) => ({
			name,
			...cred
		}));

	return {
		toast: state.credentials && state.credentials.toast,
		credentials: namedCreds,
		error: state.credentials.error,
		errorDetail: state.credentials.errorDetail,
		loading: state.credentials.loading
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Credentials);
